var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", [_vm._v("Select a new date or leave empty to clear the date")]),
    _c(
      "div",
      { staticClass: "md-layout" },
      [
        _c(
          "md-datepicker",
          {
            attrs: {
              "md-immediately": "",
              "md-debounce": 10,
              "md-disabled-dates": _vm.disabledDates,
            },
            model: {
              value: _vm.selectedDate,
              callback: function ($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate",
            },
          },
          [_c("label", [_vm._v("Date")])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }